// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2779":"0c8559a3","6794":"0c8559a3"}[chunkId] + ".chunk.css";
};